import { TYPE } from '@kontentino/kontentino-constants/Pages';
import { PseudoPostType } from 'constants/post';
import { PostModalState } from 'app/modules/posts/modules/post/new/PostModalProvider';
import { isAssetCard } from 'utils/attachments';
import { getCardMedia } from 'app/modules/posts/utils/cardMedia';

// Networks whose publisher uploads a custom video cover. YouTube, Threads and X
// have no cover path in the scheduler or the platform API yet.
const ASSET_VIDEO_COVER_PSEUDO_TYPES: Partial<
  Record<number, PseudoPostType[]>
> = {
  [TYPE.FACEBOOK]: [PseudoPostType.Video, PseudoPostType.Reel],
  [TYPE.INSTAGRAM]: [PseudoPostType.Reel],
  [TYPE.LINKEDIN]: [PseudoPostType.Video],
  [TYPE.PINTEREST]: [PseudoPostType.Video],
  [TYPE.TIKTOK]: [PseudoPostType.Video],
};

export const publishesAssetVideoCover = (
  pageType: number | undefined,
  pseudoType: PseudoPostType,
) =>
  pageType !== undefined &&
  !!ASSET_VIDEO_COVER_PSEUDO_TYPES[pageType]?.includes(pseudoType);

export const canSetupAssetVideoThumbnail = ({
  page,
  pseudoType,
  attachments,
}: Pick<PostModalState, 'page' | 'pseudoType' | 'attachments'>) => {
  const [card] = attachments.cards;

  return (
    attachments.cards.length === 1 &&
    publishesAssetVideoCover(page?.type, pseudoType) &&
    isAssetCard(card) &&
    card.asset.type === 'video' &&
    getCardMedia(card)?.status === 'ready'
  );
};
